import Parse from 'parse';
import React, { useState } from "react";
import { Button, Modal, Spin, Form, Input } from 'antd';

const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  };
  
const DetailModal = ({visible, onClose}) => {
    // Form Hook
    const [form] = Form.useForm();

    // Handle loading
    const [ isLoading, setIsLoading ] = useState(false);

    // Control state
    const saveCustomer = () => {
        // Get form values
        const latestValues = form.getFieldsValue(true);
        
        // Update changes in new Product
        const Customer = Parse.Object.extend("PotentialCustomer");
        const potentialCustomer = new Customer();

        Object.keys(latestValues).forEach((key) => {
            potentialCustomer.set(key, latestValues[key]);
        });

        // Upload to database
        potentialCustomer.save()
        .then((result) => {
            setIsLoading(false);
            Modal.success({title: 'Solicitud en proceso', content: 'Un asesor se pondrá en contacto contigo'});
            form.resetFields(); // Reset forms before set default values
            onClose();
        }, (error) => {
            setIsLoading(false);
            Modal.error({title: 'Algo salió mal', content: 'Por favor intenta nuevamente'});
            form.resetFields(); // Reset forms before set default values
            onClose();
        });
    };

    const newCustomerRequest = () => {
        form.validateFields()
        .then(values => {
            setIsLoading(true);
            saveCustomer();
        })
        .catch(errorInfo => {
            //console.log('ERROR', errorInfo);
            Modal.error({title: 'Reivsa el formulario', content: 'Hay datos faltantes o erroneos'});
        });
    };

    // Control render
    let title = 'Pérmitenos ayudarte';
    let actionName = 'Solicitar';

    const showModalContent = () => {
        if(isLoading) return (<Spin size="large"/>);

        else {
            return(
            <Form
                {...formItemLayout}
                form={form}
                name="newCustomer"
                requiredMark={false}
                layout='horizontal'
                scrollToFirstError
                >
                <Form.Item
                        name="name"
                        label="Nombre"
                        rules={[
                            {
                                min: 5,
                                message: '¿Quién nos contacta?',
                            },
                            {
                                required: true,
                                message: '¿Quién nos contacta?',
                            }
                        ]}
                    >
                        <Input/>
                </Form.Item>
                <Form.Item
                        name="email"
                        label="Correo"
                        rules={[
                            {
                                pattern: new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,}$'),
                                message: 'El correo no es válido',
                            },
                            {
                                required: true,
                                message: 'El correo no es válido',
                            }
                            ]}
                    >
                        <Input/>
                </Form.Item>
                <Form.Item
                        name="phone"
                        label="Teléfono"
                        rules={[
                            {
                                pattern: new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/),
                                message: 'Ingresa un número de teléfono válido',
                            },
                            {
                                required: true,
                                message: 'Ingresa un número de teléfono válido',
                            }
                        ]}
                    >
                        <Input/>
                </Form.Item>
                <Form.Item
                        name="msg"
                        label="Mensaje"
                        rules={[
                            { 
                                min: 20, 
                                message: 'Cuéntanos un poco más' 
                            },
                            {
                                required: true,
                                message: 'Cuéntanos un poco más',
                            }
                        ]}
                >
                        <Input.TextArea autoSize={{ minRows: 3, maxRows: 6 }} placeholder="Cuéntanos un poco acerca de lo que buscas"/>
                </Form.Item>
            </Form>
            );
        }
    };

    return (
        <Modal
            title={title}
            open={visible}
            closable={false}
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>
                    Cancelar
                </Button>,
                <Button key="update" type="primary" onClick={newCustomerRequest}>
                    {actionName}
                </Button>
              ]}>
            {showModalContent()}
        </Modal>
    );
  }
  
export default DetailModal;